import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// The local-only category preview skips auth, analytics and all live app clients.
const App = React.lazy(() =>
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_WEIGHT_LOSS_LOCAL_PREVIEW === 'true' &&
  // eslint-disable-next-line no-undef
  window.location.hostname === '127.0.0.1'
    ? import('./features/talo-next/weight-loss/preview-app')
    : import('./app/App')
);
import reportWebVitals from './reportWebVitals';

// eslint-disable-next-line no-undef
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<p>Loading Talo…</p>}>
      <App />
    </React.Suspense>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
